(ns ui.view.card.shared-components.view
  (:require
   [ui.components.button.view :as button]
   [ui.view.card.event :as event]
   [re-frame.core :as rf]))

(defn expand-card
  [{:keys [ctx] :as _props}]
  [button/secondary-open
   {:on-click #(rf/dispatch [::event/toggle-full-screen ctx])}
   [:i.fal.fa-expand-arrows.alt]])

(defn edit-mode
  [{:keys [on-click]}]
  [button/secondary-open
   {:on-click on-click}
   [:i.fal.fa-pencil]])
